import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDeepDive: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDeepDive"><Path d="M14.4961 20C14.4961 12.5 23.4878 13.4655 21.0953 4C17.9106 7.68103 14.8695 6 11.9966 8.5C9.12376 6 6.08166 7.68103 2.89695 4C0.504935 14.5172 9.4961 12.2233 9.4961 19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 20.5C9.13579 17.5 13.8913 22.75 21.5 19" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDeepDive;
